import { DesignParameterState } from 'records/DesignParameter';
import {
  DESIGNPARAMETER_UPDATE_ACTION_SUCCESS,
  DESIGNPARAMETER_RESET_STATE,
  DESIGNPARAMETER_UPDATE_SAVED_STATE,
  DESIGNPARAMETER_UPDATE_EXISTING_STATE,
} from 'actions/designParameter';

const initialState = new DesignParameterState();

const actionsMap = {
  [DESIGNPARAMETER_RESET_STATE]: () => {
    return initialState;
  },

  [DESIGNPARAMETER_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGNPARAMETER_UPDATE_SAVED_STATE]: (state, action) => {
    const { isUpdated } = action.data;
    return state.merge({
      hasUpdated: isUpdated,
    });
  },
  [DESIGNPARAMETER_UPDATE_EXISTING_STATE]: (state, action) => {
    const { isExisting } = action.data;
    return state.merge({
      isExisting,
    });
  },
};

export default function designParameter(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
